export default __webpack_public_path__ + "static/media/spotify.a264cbc7.svg";